// Copyright © 2021 Move Closer

export type ElementFactory = (type?: string) => Promise<unknown> | unknown

export enum MoveDirection {
  Down = 'down',
  Up = 'up'
}
